<template>
  <div class="service-courses">
    <!-- 类别一 -->
    <section>
      <div class="nav1-top">
        <ul>
          <li @click="tabChange('0')" :class="{ active: courseType === '0' }">
            <span>电商运营</span>
            <div class="bc"></div>
          </li>
          <li @click="tabChange('1')" :class="{ active: courseType === '1' }">
            <span>电子商务法</span>
            <div class="bc"></div>
          </li>
          <li @click="tabChange('2')" :class="{ active: courseType === '2' }">
            <span>商务活动</span>
            <div class="bc"></div>
          </li>
          <li @click="tabChange('3')" :class="{ active: courseType === '3' }">
            <span>共享培训课件</span>
            <div class="bc"></div>
          </li>
          <!-- <li @click="tabChange('3')" :class="{active: courseType === '3'}">
            <span>惠民惠企</span>
            <div class="bc" ></div>
          </li> -->
        </ul>
      </div>
      <transition appear name="fade">
        <div class="content">
          <div class="course-item" v-for="item in courseList" :key="item.id">
            <div
              class="item-detail"
              @click="navToVideo(item.link ? item.link : item.id,item)"
            >
              <img
                v-lazy="item.thumb"
                :alt="item.description"
                :title="item.description"
              />
              <p v-html="item.title"></p>
              <div>
                <i class="el-icon-user">
                  {{ item.author }}
                </i>
                <i class="el-icon-video-play"> {{ item.playCount }}次 </i>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="foot-page">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.page"
          :page-size="queryInfo.limit"
          layout="total, prev, pager, next"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { courseListt,uploadVideoCount,getPVUV } from "@apis/apis";
import { showcontent } from "@utils/method.js";
export default {
  name: "servicesCourse",
  data() {
    return {
      courseList: [],
      playCount:0,
      queryInfo: {
        page: 1,
        limit: 16,
      },
      totalCount: 0,
      courseType: "0",
    };
  },
  created() {
    this.getCourseTypeOne();
    this.getpvuv()
  },
  methods: {
    //埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "服务体系",
        directoryTwo: '课程资源',
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    showcontent,
    getCourseTypeOne() {
      this.$ajaxPost(courseListt, this.queryInfo, {
        videoType: this.courseType,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.courseList = data.data.list;
          this.courseList.forEach((e) => {
            e.title = showcontent(e.title);
          });
          this.totalCount = data.data.totalCount;
        }
      });
    },
    // 点击跳转到看视频
    navToVideo(id,b) {
      if (id.length > 10) {
        window.open(id, "_blank");
        this.playCount =  b.playCount ++ 
        this.updataVideoCount(b)
      } else {
        this.$router.push({ name: "ServicesVideo", query: { id } });
      }
      // this.$router.push({ name: "ServicesVideo", query: { id } });
    },
    /**
     * @description: 离开页面刷新页面播放次数
     * @param {*}
     */
    updataVideoCount(b){
      // console.log(this.playCount);
      // return
      this.$ajaxGet(`${uploadVideoCount}?id=${b.id}&playCount=${this.playCount+1}`).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
        } else {
          return
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    // 给tab加上点击事件
    tabChange(type) {
      this.courseType = type;
      this.queryInfo.page = 1;
      this.getCourseTypeOne();
    },
    // 页数改变事件
    handleCurrentChange(page) {
      this.queryInfo.page = page;
      this.getCourseTypeOne();
    },
    /**
     * @description: 转义文本
     * @param {*}
     */
    showcontent(str) {
      if (!str) {
        return;
      }
      let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
  },
};
</script>

<style lang="less" scoped>
.service-courses {
  margin-top: 0.257812rem;
  width: 100%;
  border-radius: 0.06875rem;
  .nav1-top {
    font-size: 0.154687rem;
    ul {
      display: flex;
      li {
        position: relative;
        margin-right: 0.128906rem;
        padding: 0.06875rem 0.128906rem;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
        overflow: hidden;
        span {
          position: relative;
          z-index: 1;
        }
        .bc {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 0;
          background-image: linear-gradient(to top, #a3bded 0%, #6991c7 100%);
          transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1);
        }
        &.active {
          color: #fff;
          .bc {
            height: 100%;
          }
        }
      }
    }
  }
  .content {
    position: relative;
    margin: 0.171875rem -0.085937rem 0;
    display: flex;
    flex-wrap: wrap;
    .course-item {
      margin-top: 0.171875rem;
      padding: 0 0.085937rem;
      width: 25%;
      font-size: 0.1375rem;
      box-sizing: border-box;
      // background-color: #fff;
      .item-detail {
        padding: 0.1375rem 0.1375rem 0.171875rem;
        background-color: #fff;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        img {
          height: 1.375rem;
          width: 100%;
        }
        p {
          height: 0.360937rem;
          text-align: left;
          overflow: hidden;
        }
        div {
          display: flex;
          justify-content: space-between;
          font-size: 0.120312rem;
          color: #666;
        }
        &:hover {
          transform: translateY(-5px);
          box-shadow: -3px 3px 10px 3px rgba(141, 131, 131, 0.5);
        }
      }
    }
  }
  .foot-page {
    margin-top: 0.257812rem;
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .el-pagination {
      margin: 0 auto;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 200ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(40px);
  }
}
</style>